// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/sass-loader/dist/cjs.js!./OrderSummary.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(true);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".hlCartLine__2tXXz{}.dollarTotal__36xSD{}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/cart/components/OrderSummaryDiscounts.module.scss"],"names":[],"mappings":"AAAA,mBACwD,CACvD,oBAGwD","file":"OrderSummaryDiscounts.module.scss","sourcesContent":[".hlCartLine {\n  composes: hlCartLine from './OrderSummary.module.scss';\n}\n\n.dollarTotal {\n  composes: dollarTotal from './OrderSummary.module.scss';\n}\n"]}]);
// Exports
exports.locals = {
	"hlCartLine": "hlCartLine__2tXXz " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["hlCartLine"] + "",
	"dollarTotal": "dollarTotal__36xSD " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["dollarTotal"] + ""
};
module.exports = exports;
